<script>
import useSharedData from "@/use/SharedData.js";
import {onMounted, ref, watch} from "vue";
import {usePaySectionStore} from "@/stores/PaySection";
import useTools from "@/use/Tools";

export default {
    name: "StrVariableAutocomplete",
    props: {
        value: [Number, Array],
        multiple: Boolean,
        label: String,
        readonly: Boolean,
        rules: Array,
    },
    setup(props, {emit}) {
        const {loading, inputColor, backgroundColor} = useSharedData();
        const {$i18n} = useTools();

        const paySectionStore = usePaySectionStore();

        const variable = ref(null);
        const variables = ref([
            {id: 'N_HR_ABS', codeLabel: "[N_HR_ABS] " + $i18n.t('pay_slip.N_HR_ABS')},
            {id: 'N_JR_ABS', codeLabel: "[N_JR_ABS] " + $i18n.t('pay_slip.N_JR_ABS')},
            {id: 'N_HR_TRAV', codeLabel: "[N_HR_TRAV] " + $i18n.t('pay_slip.N_HR_TRAV')},
            {id: 'N_JR_TRAV', codeLabel: "[N_JR_TRAV] " + $i18n.t('pay_slip.N_JR_TRAV')},
            {id: 'N_JR_CONGE', codeLabel: "[N_JR_CONGE] " + $i18n.t('pay_slip.N_JR_CONGE')},
            {id: 'N_HR_SUP', codeLabel: "[N_HR_SUP] " + $i18n.t('pay_slip.N_HR_SUP')},
            {id: 'N_HR_OUV', codeLabel: "[N_HR_OUV] " + $i18n.t('pay_slip.N_HR_OUV')},
            {id: 'N_HR_JOUR', codeLabel: "[N_HR_JOUR] " + $i18n.t('pay_slip.N_HR_JOUR')},
            {id: 'N_JR_OUV', codeLabel: "[N_JR_OUV] " + $i18n.t('pay_slip.N_JR_OUV')}
        ]);

        watch(() => props.value, () => {
            variable.value = props.value;
        }, {immediate: true});

        function save() {
            emit('input', variable.value);
        }

        onMounted(() => {
            variables.value = variables.value.concat(paySectionStore.paySections)
        });

        return {
            loading,
            inputColor,
            backgroundColor,
            variable,
            variables,
            save,
        }
    }
}
</script>

<template>
    <div>
        <v-autocomplete
                v-model="variable"
                :label="label"
                :items="variables"
                item-value="id"
                item-text="codeLabel"
                outlined
                dense
                :multiple="multiple"
                :clearable="!readonly"
                @input="save"
                :readonly="readonly"
                :color="inputColor"
                :background-color="backgroundColor"
                :rules="rules"
                hide-details="auto"
        ></v-autocomplete>

        <input type="hidden"/>
    </div>
</template>